class StateHelper {
  public static ImmutableChange: any = (obj: object, path: string, value: any) => {
    if (!path) {
      return value;
    }
    const relativePaths = path.split('.');
    return {
      ...obj,
      [relativePaths[0]]: StateHelper.ImmutableChange(
        obj[relativePaths[0]],
        relativePaths.slice(1).join('.'),
        value
      ),
    };
  };
}

export default StateHelper;



// WEBPACK FOOTER //
// ./src/modules/shared/helpers/StateHelper.tsx